const SECTION_CODE_PATTERN = /^S[A-Z0-9]+$/;

function resolveSectionSuggestionCode(
  sectionId: string,
  sectionCode?: string
): string | undefined {
  if (sectionCode?.trim()) {
    return sectionCode;
  }

  if (sectionId === "Vitals") {
    return "SVIT";
  }

  return SECTION_CODE_PATTERN.test(sectionId) ? sectionId : undefined;
}

const SECTION_CODES_WITHOUT_FORM_BRIDGE = new Set(["SVIT", "SPOF"]);

function canApplySuggestionsToSection(sectionCode?: string): boolean {
  return (
    Boolean(sectionCode) &&
    !SECTION_CODES_WITHOUT_FORM_BRIDGE.has(sectionCode as string)
  );
}

function normalizeSectionKey(value: string): string {
  return value
    .trim()
    .replace(/(?:\s*,\s*)+$/g, "")
    .trim()
    .toLowerCase();
}

function sectionKeysMatch(left: string, right: string): boolean {
  return normalizeSectionKey(left) === normalizeSectionKey(right);
}

function suggestionSectionCodeBelongsToSection(
  suggestionSectionCode: string,
  sectionId: string,
  sectionTitle?: string
): boolean {
  if (!suggestionSectionCode.trim() || !sectionId.trim()) {
    return false;
  }
  if (sectionKeysMatch(suggestionSectionCode, sectionId)) {
    return true;
  }
  if (!sectionTitle?.trim()) {
    return false;
  }
  return sectionKeysMatch(suggestionSectionCode, sectionTitle);
}

export {
  SECTION_CODE_PATTERN,
  SECTION_CODES_WITHOUT_FORM_BRIDGE,
  canApplySuggestionsToSection,
  resolveSectionSuggestionCode,
  suggestionSectionCodeBelongsToSection,
};
